/*
  Separador de miles en los puntos que pinta Yotpo.

  Vivia dentro del `code` de un bloque custom-liquid de
  `page.recompensas-yotpo`, o sea que ocupaba una SECCION entera de las 25
  que Shopify admite por plantilla. El 23/09 pasa a asset y se emite desde
  `theme.liquid`, junto a `rewards.css`.

  Reescrito el 22/09. La version anterior fallaba por cuatro sitios, y los
  cuatro estan medidos:

  1. Se enganchaba a `window.onload`, que corre ANTES de que Yotpo pinte sus
     widgets, asi que unas veces llegaba y otras no. Ademas pisaba cualquier
     otro `window.onload` de la pagina.
  2. Solo miraba `.yotpo-redemption-option-cost`, la rejilla. El modal de
     movil usa otra clase, y por eso ahi salia "12500 puntos".
  3. Su expresion topaba en 7 cifras, asi que un numero de 8 salia PARTIDO:
     12345678 -> "1,234,5678".
  4. Su `(?!\d*,)` saltaba numeros legitimos si mas adelante en el mismo
     texto habia una coma: "6000, 12500" -> "6000, 12,500".

  Ahora corre una vez al cargar y vuelve a correr cuando el DOM cambia, que
  es lo que cubre el pintado tardio de Yotpo, la apertura del modal y el
  movimiento del carrusel.

  El carrusel de eventos NO lo toca, y no deberia: es nuestro, lo imprime
  `custom-reward-redeemed-dea` desde un metaobjeto, asi que ahi el separador
  va en Liquid, sin carrera ni parpadeo.
*/
(function () {
  var SELECTOR = '.yotpo-redemption-option-cost, .yotpo-redemption-cost-mobile-modal';

  function formatea(elemento) {
    var paseo = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = paseo.nextNode())) {
      if (!/\d{4}/.test(nodo.nodeValue)) continue;
      var nuevo = nodo.nodeValue.replace(/\d{4,}/g, function (n) {
        return Number(n).toLocaleString('es-MX');
      });
      // Solo se escribe si de verdad cambia: asi el observador de abajo no se
      // despierta con su propio cambio.
      if (nuevo !== nodo.nodeValue) nodo.nodeValue = nuevo;
    }
  }

  // Se recorren los nodos de TEXTO y no se reescribe el textContent del
  // contenedor, que se llevaria por delante el marcado que Yotpo tenga dentro.
  function pasada() {
    var nodos = document.querySelectorAll(SELECTOR);
    for (var i = 0; nodos.length > i; i++) formatea(nodos[i]);
  }

  pasada();

  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      pasada();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
